/**
 * UYAP oturumunun kime ait olduğunun denetimi.
 *
 * Görevler hesaba bağlıdır; bir avukatın UYAP oturumuyla başkasının görevleri
 * işlenmemeli. Bunun için üç kimlik de tutmalı: hesap TC == kart TC == oturum TC.
 *
 * Saf tutulur (store/socket bağımlılığı yok) ki birim testten geçebilsin.
 */

/** Karşılaştırma için yalnızca rakamları alır. Bilinmeyen değer boş string döner. */
export function tcknNormalize(deger: any): string {
    return String(deger ?? '').replace(/\D/g, '');
}

export interface KimlikDenetimSonucu {
    uyusuyor: boolean;
    /** Uyuşmuyorsa hangi kimliğin çeliştiği — loglama için. */
    sebep?: 'hesap' | 'kart';
}

/**
 * Oturum, hesap ve takılı kart aynı kişiye mi ait?
 *
 * Bilinmeyen (boş) değerler karşılaştırmaya girmez: kimliği doğrulayamamak,
 * uyuşmazlık kanıtı değildir. Bu yüzden eksik veri bağlantıyı düşürmez.
 */
export function oturumKimligiUyusuyor(kimlikler: {
    oturum?: any;
    hesap?: any;
    kart?: any;
}): KimlikDenetimSonucu {
    const oturum = tcknNormalize(kimlikler.oturum);
    if (!oturum) {
        return {uyusuyor: true};
    }

    const hesap = tcknNormalize(kimlikler.hesap);
    if (hesap && hesap !== oturum) {
        return {uyusuyor: false, sebep: 'hesap'};
    }

    const kart = tcknNormalize(kimlikler.kart);
    if (kart && kart !== oturum) {
        return {uyusuyor: false, sebep: 'kart'};
    }

    return {uyusuyor: true};
}
